module.exports = __webpack_public_path__ + "static/media/banner-photo768.9511718c.jpg";